import types from "../actionTypes";
import LoadingState from "../../utils/loading-state";

const INITIAL_STATE = {
  invitation: null,
  invitationLoadingState: LoadingState.UNINITIALIZED,
  invitationError: null,
  createdInvitation: null,
  createInvitationLoadingState: LoadingState.UNINITIALIZED,
  createInvitationError: null
};

const invitationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_INVITATION_REQUEST:
      return {
        ...state,
        invitationLoadingState: LoadingState.IN_PROGRESS,
        invitationError: null
      };
    case types.GET_INVITATION_SUCCESS:
      return {
        ...state,
        invitationLoadingState: LoadingState.COMPLETED,
        invitation: action.payload.invitation
      };
    case types.GET_INVITATION_FAILURE:
      return {
        ...state,
        invitationLoadingState: LoadingState.FAILED,
        invitationError: action.payload.error
      };

    case types.CREATE_INVITATION_REQUEST:
      return {
        ...state,
        createInvitationLoadingState: LoadingState.IN_PROGRESS,
        createInvitationError: null
      };
    case types.CREATE_INVITATION_SUCCESS:
      return {
        ...state,
        createInvitationLoadingState: LoadingState.COMPLETED,
        createdInvitation: action.payload
      };
    case types.CREATE_INVITATION_FAILURE:
      return {
        ...state,
        createInvitationLoadingState: LoadingState.FAILED,
        createInvitationError: action.payload.error
      };

    default:
      return state;
  }
};

export default invitationsReducer;

export const selectInvitation = (invitationData) => invitationData.invitation;
export const selectInvitationLoadingState = (invitationData) =>
  invitationData.invitationLoadingState;
export const selectInvitationError = (invitationData) =>
  invitationData.invitationError;

export const selectCreatedInvitation = (invitationData) =>
  invitationData.createdInvitation;
export const selectCreateInvitationLoadingState = (invitationData) =>
  invitationData.createInvitationLoadingState;
export const selectCreateInvitationError = (invitationData) =>
  invitationData.createInvitationError;
export const selectInvitationClonedDiscovery = (invitationData) =>
  invitationData.clonedDiscovery;
